import { init as nl__init, downloadOnClick } from "./init.js";
import { init as barbaInit, curtainPull } from "./barba.js";
import { init as hooks} from "./hooks.js";
import { init as lenis } from "./lenis.js";


barbaInit();
hooks();
lenis();

jQuery(function () {  
       //console.log('jQuery first time');
       nl__init();
       curtainPull();
       downloadOnClick();
       
});